import { useFeatureFlag } from '@raisin/cp-utils';
import { useT } from '@transifex/react';
import { useMemo } from 'react';
import { markets } from '../../layout/Footer/v2/CountryPickerConfig';
export const useMarkets = () => {
    var _a;
    const t = useT();
    const { variation } = useFeatureFlag();
    const b2cUnifiedDomainLocales = variation === null || variation === void 0 ? void 0 : variation('b2cUnifiedDomainLocales', '');
    const b2cNewMarketLocales = variation === null || variation === void 0 ? void 0 : variation('b2cNewMarketLocales', {});
    const b2cUnifiedDomainLocalesList = (_a = b2cUnifiedDomainLocales === null || b2cUnifiedDomainLocales === void 0 ? void 0 : b2cUnifiedDomainLocales.split(',')) !== null && _a !== void 0 ? _a : [];
    return useMemo(() => {
        const formattedMarkets = markets(t, b2cUnifiedDomainLocalesList);
        if (!b2cNewMarketLocales || !Object.keys(b2cNewMarketLocales).length) {
            return formattedMarkets;
        }
        return Object.fromEntries(Object.entries(formattedMarkets).filter(([key]) => {
            const locale = formattedMarkets[key].locale.toLowerCase();
            // This is to support existing markets
            if (!Object.keys(b2cNewMarketLocales).includes(locale))
                return true;
            // New domains will have value as false if not enabled yet and true if it is enabled
            return b2cNewMarketLocales[locale];
        }));
    }, [t, b2cUnifiedDomainLocalesList, b2cNewMarketLocales]);
};
//# sourceMappingURL=useMarkets.js.map